// DynamicForm.js
import React, { useState, useEffect } from 'react';
 

const FormHeader = () => {  
  return (
  <>
  <div>
    <div class="w-100 font-secondary d-inline-block text-center h6 fw-normal bg-theme-yellow-7 p-2"><b>Inception Form Url</b> : https//doublediamond.ayatacommerce.com/inception-form/UYUNM340</div>
  </div>
    <div className="fs-5 px-2 d-flex container-xl align-items-center justify-content-center border borer-1 border-start-0 border-end-0 py-2 ">
      <div className='me-3'>  
            <label htmlFor="projectType" className=' pb-2 text-primary'>Type : </label><br/>          
            <select className='p-1' id="projectType" >
              <option value="New">New</option>
              <option value="Revamp">Revamp</option>              
            </select>
        </div>

        <div className='me-3'>
            <label htmlFor="projectType" className=' pb-2  text-primary'>Project : </label><br/>
            <select  className='p-1' id="projectType">
              <option value="Website">Website</option>
              <option value="Web App">Web App</option>
              <option value="Mobile App">Mobile App</option>
            </select>
        </div>
        <div>
            <label htmlFor="projectType" className=' pb-2  text-primary'>Industry : </label><br/>
            <select className='p-1' id="projectType" >
                  <option value="E-Commerce">E-Commerce</option>
                  <option value="FinTech">FinTech</option>
                  <option value="Healthtech">Healthtech</option>
                  <option value="EdTech">EdTech</option>
                  <option value="Travel">Travel</option>     
            </select>
        </div>

      </div>
      <div className='text-center'>
          <div className='h4 font-secondary pb-2 d-inline-block my-3 text-center border-bottom border-4 border-theme-pink'>Project Kickoff Questionnaire (New Website for the E-commerce Industry)</div>
    </div>
    </>
  );
};

export default FormHeader;